import { Box, Card, CardContent, CardHeader, Divider, FormLabel } from '@mui/material';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import Markdown from 'markdown-to-jsx';

type Props = {
  content: any;
  showLabel?: boolean;
  label?: string;
  error?: string;
  maxHeight?: number;
  useMarkdown?: boolean;
};

const TextViewer = ({
  content,
  showLabel = true,
  label,
  error,
  maxHeight = 0,
  useMarkdown = true,
}: Props) => {
  const [headerRef, headerSize] = useElementSize();

  const stringContent = typeof content === 'string' ? content : String(content ?? '');

  const computedMaxHeight =
    maxHeight > 0
      ? Math.max(80, maxHeight - (headerSize.height > 0 ? 2 * headerSize.height : 0))
      : 'none';

  return (
    <Card variant="outlined" sx={{ border: label || error ? 1 : 0, borderColor: 'divider', width: '100%', maxWidth: '100%' }}>
      {showLabel && (label || error) && (
        <CardHeader ref={headerRef} disableTypography title={label ? <FormLabel>{label}</FormLabel> : ''} />
      )}
      {showLabel && (label || error) && <Divider />}
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box
          sx={{
            maxWidth: '100%',
            width: '100%',
            overflow: 'auto',
            maxHeight: computedMaxHeight,
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            typography: 'body2',
            fontSize: '0.82rem',
            lineHeight: 1.6,
          }}
        >
          {useMarkdown ? <Markdown>{stringContent}</Markdown> : stringContent}
        </Box>
      </CardContent>
    </Card>
  );
};

export default TextViewer;
